import type { ContractType } from '@/graphql/generated';
import { useServices } from '@/core/composables/services';
import { GetAccountOfferContract, GetPreviewOfferContract } from '@/parts/objects/gql/offerContracts';

export const useOfferContractsStore = () => {
  const { $api } = useServices();

  const getPreviewOfferContract = (legalCid: string, accommodationObjectCid: string, contractType: ContractType) =>
    $api.query<{ getPreviewOfferContract: { data: string } }>(GetPreviewOfferContract, {
      legalCid,
      accommodationObjectCid,
      contractType,
    });

  const getAccountOfferContract = (contractNumber: number) =>
    $api.query<{ getAccountOfferContract: { data: string } }>(GetAccountOfferContract, { contractNumber });

  return {
    getPreviewOfferContract,
    getAccountOfferContract,
  };
};
